import top from './zh/top'

const lang = {
	top,
}

export default lang;